import { spaceBookingsAPI } from '../utils/api';

/**
 * One answer per signed-in person to "may I book a room myself?".
 *
 * Several surfaces ask at once — the dashboard card, My Bookings, the route
 * guard — so the request is made once and shared. It lives in its own module
 * rather than beside the hook because AuthContext clears it on sign-out, and
 * the hook reads AuthContext: keeping the cache separate keeps those two from
 * importing each other.
 *
 * It fails closed. An error, a refused request, or a reply that does not
 * plainly say yes all mean no, so a button is never offered for something the
 * POST will refuse.
 */

let cache = { key: null, promise: null };

/** Forget the cached answer — on sign-out, and in tests. */
export function clearRoomAccessCache() {
  cache = { key: null, promise: null };
}

export function fetchRoomAccess(userId) {
  const key = String(userId);
  if (cache.key !== key) {
    cache = {
      key,
      promise: spaceBookingsAPI.myRoomAccess()
        .then((r) => r?.enabled === true)
        .catch(() => false),
    };
  }
  return cache.promise;
}
